module.exports = __webpack_public_path__ + "static/toolshed-a9e1f986f03e3c982c4a34c2addd30c3.jpg";